/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/no-deprecated */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { BlobProvider } from '@react-pdf/renderer';
import { faFileAlt } from '@fortawesome/fontawesome-free-solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as actions from '../../actions/index';
import {
  MenuQuinzaineBilling,
  MenuYearBilling,
  InvoiceTemplate,
  Button,
  Title,
  Paper,
  Spinner
} from '../../components';
import {
  updateBilling,
  handleClick,
  handleClickYear,
  handleClose,
  handleFetchData,
  handleUpdateYear,
  createInvoicePeriod
} from './Invoice.services';

import { styles } from './Invoice.styles';

class Invoice extends React.Component {
  state = {
    isLoading: true,
    anchorEl: null,
    anchorElYear: null,
    currentYear: moment().year(),
    optionFinance: [],
    accesArray: [],
    selectedEntity: 0,
    periode: 'En recherche ...',
    dateAndMonth: {},
    loadingInvoice: false
  };

  async componentDidMount() {
    await createInvoicePeriod(this.props, this);
    this.setState({
      isLoading: false
    });
  }

  async componentDidUpdate(prevProps) {
    const { dateAndMonth } = this.state;
    const { shopId, isAllShops } = prevProps;
    const { shopId: oldShopId, isAllShops: oldIsAllShops } = this.props;

    if (shopId !== oldShopId || (shopId === oldShopId && oldIsAllShops !== isAllShops)) {
      this.setState({ loadingInvoice: true });
      const { isAllShops } = this.props;
      await updateBilling(this, dateAndMonth, isAllShops);
      this.setState({
        loadingInvoice: false
      });
    }
  }

  render() {
    const {
      legal,
      networkLegal,
      creditorNetwork,
      shopId,
      classes,
      showHelpModal,
      isAllShops
    } = this.props;
    const {
      optionFinance,
      anchorEl,
      anchorElYear,
      periode,
      billing,
      currentYear,
      dateAndMonth,
      loadingInvoice
    } = this.state;
    return (
      <div className='px-4 pb-4'>
        <Title title='Factures' onClick={() => showHelpModal('factures')} />
        {this.state.isLoading ? (
          <center>
            <Spinner className={classes.progress} />
          </center>
        ) : (
          <div>
            <div className='py-3'>
              <Paper className={classes.root}>
                <div className='pb-3 d-flex flex-row'>
                  <Button
                    variant='contained'
                    color='secondary'
                    outlined
                    className='bg-white'
                    onClick={e => handleClick(e, this)}
                  >
                    {periode}
                  </Button>
                  <MenuQuinzaineBilling
                    optionFinance={optionFinance}
                    periode={periode}
                    anchorEl={anchorEl}
                    currentYear={currentYear}
                    handleClose={() => handleClose(this)}
                    handleFetchData={e => handleFetchData(e, this, this.props)}
                  />
                  <>
                    <Button
                      variant='contained'
                      color='secondary'
                      outlined
                      className='bg-white'
                      onClick={e => handleClickYear(e, this)}
                    >
                      {currentYear}
                    </Button>
                    <MenuYearBilling
                      optionFinance={optionFinance}
                      anchorElYear={anchorElYear}
                      currentYear={currentYear}
                      handleClose={() => handleClose(this)}
                      handleUpdateYear={e => handleUpdateYear(e, this)}
                    />
                  </>
                </div>
                {loadingInvoice && (
                  <div style={{ height: '1300px' }}>
                    <center className='mt-5'>
                      <Spinner />
                    </center>
                  </div>
                )}
                {!loadingInvoice && (
                  <BlobProvider
                    document={
                      <InvoiceTemplate
                        legal={isAllShops ? networkLegal : legal}
                        isNetworkChecked={isAllShops}
                        creditorLegal={isAllShops ? creditorNetwork : networkLegal}
                        billings={billing}
                        dateInfo={dateAndMonth}
                        year={currentYear}
                        shopId={shopId}
                      />
                    }
                  >
                    {({ url, loading }) => {
                      const hasTouchscreen = 'ontouchstart' in window;
                      return loading ? (
                        'Loading...'
                      ) : hasTouchscreen ? (
                        <Paper variant='outlined' className={classes.paper}>
                          <FontAwesomeIcon icon={faFileAlt} className={classes.iconFile} />
                          <Button outlined color='secondary' onClick={() => window.open(url)}>
                            Voir la facture
                          </Button>
                        </Paper>
                      ) : (
                        <embed width='100%' height='1300px' src={url} />
                      );
                    }}
                  </BlobProvider>
                )}
              </Paper>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => {
  const {
    legal,
    creditorNetwork,
    shopId,
    companyId,
    isAllShops,
    shopName,
    networkLegal,
    generalAdmin,
    configLegal
  } = user;
  return {
    legal,
    networkLegal,
    creditorNetwork,
    shopId,
    companyId,
    isAllShops,
    shopName,
    generalAdmin,
    configLegal
  };
};

Invoice.propTypes = {
  classes: PropTypes.element.isRequired
};

export default connect(mapStateToProps, actions)(withStyles(styles)(Invoice));
